import home_main_img_mbl from "../assets/PHONE COPY 01.webp";
import home_main_img from "../assets/WED 03 (1).webp";
import { cls } from "../assets/Utility.tsx";
import rg_logo from "../assets/RG copy 2.png";
import rg_logo_footer from "../assets/Feed Logo white.png";
import WeddingGallery from "./weddingGallery.jsx";
import WeddingGal from "./weddingGal.jsx";
import home_eye_pic from "../assets/home main pic (1) (1) (1).webp";
import { useState } from "react";

export default function Home() {
  const [result, setResult] = useState("");
  const [showMessage, setShowMessage] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    guestCount: "",
    weddingDetails: "",
    location: "",
    eventDates: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending...");
    setShowMessage(true);

    const formDataToSend = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      formDataToSend.append(key, value);
    });

    formDataToSend.append("access_key", "bfb4ffa8-be7a-4676-b16c-802a5d810b24");

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formDataToSend,
      });

      const data = await response.json();

      if (data.success) {
        setResult("Thank you. Your enquiry has been received.");
        setFormData({
          name: "",
          email: "",
          phoneNumber: "",
          guestCount: "",
          weddingDetails: "",
          location: "",
          eventDates: "",
        });
      } else {
        setResult(data.message || "Unable to submit. Please try again.");
      }
    } catch (error) {
      console.error("Form submission error:", error);
      setResult("Something went wrong. Please try again later.");
    } finally {
      setShowMessage(true);
      setTimeout(() => setShowMessage(false), 4000);
    }
  };

  return (
    <>
      {/* #segment -01 */}
      <div className="xl:flex hidden">
        <img
          src={home_main_img}
          alt="premium wedding photography"
          className="w-full h-screen object-cover"
        />
      </div>
      <div className="xl:hidden flex">
        <img
          src={home_main_img_mbl}
          alt="premium wedding photography"
          className="w-full h-screen object-cover"
        />
      </div>
      {/* <div className={cls("hidden xl:flex w-full h-screen overflow-hidden")}>
        <video
          className="w-full h-full object-cover block"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
        >
          <source src={home_main_fim} type="video/mp4" />
        </video>
      </div> */}
      {/* <div className={cls(" xl:hidden flex  w-full h-screen overflow-hidden")}>
        <video
          className="w-full h-full object-cover block"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
        >
          <source src={home_main_fim} type="video/mp4" />
        </video>
      </div> */}
      {/* #segment-02 */}
      <p
        className={cls(
          " text-[17px] font-[description1] mt-[40px] mb-[10px] text-black text-center xl:pl-[380px] xl:pr-[380px] pl-[20px] pr-[20px]",
        )}
      >
        We chase the light, the movement, the fleeting seconds that somehow hold
        a lifetime within them. Inspired by human connections and the beauty of
        imperfection, we find our stories in spontaneous laughter, familiar
        rituals, quiet anticipation, and everything in between.
      </p>
      <div className="flex justify-center items-center">
        <img
          src={rg_logo}
          alt="wedding photography"
          className="w-[80px] h-[80px] object-contain"
        />
      </div>
      <p
        className={cls(
          " text-[17px] font-[description1] mt-[10px] mb-[50px] text-black text-center xl:pl-[380px] xl:pr-[380px] pl-[20px] pr-[20px]",
        )}
      >
        {" "}
        Our films take shape beyond timelines and conventions, where images,
        sounds, and emotions come together in a rhythm of their own. Balancing
        the timelessness of our traditions with a fresh cinematic language, we
        create visual narratives that are deeply personal, beautifully
        unfiltered, and made to outlive the moment.
      </p>
      <p
        className={cls(
          " text-[30px] font-[description1] mt-[30px] mb-[30px]  text-center xl:pl-[380px] xl:pr-[380px] pl-[20px] pr-[20px]",
        )}
      >
        See Our Work
      </p>
      {/* desktop grid */}
      <div className=" xl:pt-[20px] xl:pb-[20px] xl:flex xl:items-center hidden">
        <WeddingGallery />
      </div>
      {/* mobile grid */}
      <div className=" pt-[20px] pb-[20px] xl:hidden">
        <WeddingGal />
      </div>

      <p
        className={cls(
          " text-[17px] font-[description1] mt-[30px] mb-[30px] text-black text-center xl:pl-[370px] xl:pr-[370px] pl-[20px] pr-[20px]",
        )}
      >
        A new beginning for an age-old tradition, where timeless rituals meet a
        fresh perspective. Rooted in rich heritage and reimagined through our
        lens, we capture the soul of every celebration, preserving its beauty
        for generations to come
      </p>
      <div className="flex justify-center items-center">
        <img
          src={rg_logo}
          alt="wedding photography"
          className="w-[80px] h-[80px] object-contain"
        />
      </div>

      <img
        src={home_eye_pic}
        alt="premium wedding bangalore photography"
        className="w-full h-full object-cover mb-[50px]"
      />
      <div className="flex flex-col items-center justify-center pl-[20px] pr-[20px] xl:pl-[380px] xl:pr-[380px] mb-[50px] gap-[10px]">
        <p className="uppercase tracking-widest"> Follow us on Instagram</p>

        <a
          className="tracking-wider text-[18px]"
          href="https://www.instagram.com/storiesby.rg?utm_source=ig_web_button_share_sheet&vrfl=ZDNlZDc0MzIxNw=="
        >
          <i> @storiesby.rg</i>
        </a>
      </div>

      <div className="bg-[#2E2526] pt-[40px] pb-[40px] flex flex-col gap-[30px] items-center justify-center xl:pl-[380px] xl:pr-[380px] pr-[20px] pl-[20px]">
        <p className="tracking-wide font-[description1] xl:text-[50px] text-[30px] text-[#F8F5F0] ">
          LET US CAPTURE
          <br />
          YOUR <em className="xl:text-[30px] text-[20px] tracking-normal">Unforgettable</em>
          <br />
          MOMENTS
        </p>
        <p className="font-[description1] text-[17px] text-[#F8F5F0]">
          Share a few details about your celebration below, and let us
          understand the vision behind it. From the nuances of your traditions
          to the moments you wish to hold onto forever, every detail helps us
          craft a considered, bespoke quotation tailored to your story.
          <br />
          <br />
          We will be in touch within 24 hours. For celebrations approaching soon
          or enquiries that require immediate attention, please contact us
          directly at the number below.
        </p>
        {/* form */}

        <form onSubmit={handleSubmit} className="xl:w-[600px] w-[300px]">
          <div className="flex flex-col gap-[20px] ">
            {/* Name */}
            <input
              type="text"
              name="name"
              autoComplete="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="border-b-[1px] border-[#F8F5F0] bg-[#2E2526] w-full p-[10px] outline-none placeholder:text-[#F8F5F0] text-[17px] font-[description1]"
              placeholder="Name"
            />

            {/* Email */}
            <input
              type="email"
              name="email"
              autoComplete="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="border-b-[1px] border-[#F8F5F0] bg-[#2E2526] w-full p-[10px] outline-none placeholder:text-[#F8F5F0] text-[17px] font-[description1]"
              placeholder="Email "
            />

            {/* Phone Number */}
            <input
              type="tel"
              name="phoneNumber"
              autoComplete="tel"
              value={formData.phoneNumber}
              onChange={handleChange}
              required
              className="border-b-[1px] border-[#F8F5F0] bg-[#2E2526] w-full p-[10px] outline-none placeholder:text-[#F8F5F0] text-[17px] font-[description1]"
              placeholder="Phone Number"
            />

            {/* Estimated Guest Count */}
            <input
              type="text"
              name="guestCount"
              value={formData.guestCount}
              onChange={handleChange}
              placeholder="Estimated Guest Count"
              className="border-b-[1px] border-[#F8F5F0] bg-[#2E2526] w-full p-[10px] outline-none placeholder:text-[#F8F5F0] text-[17px] font-[description1]"
            />

            {/* Wedding Details */}
            <textarea
              name="weddingDetails"
              value={formData.weddingDetails}
              onChange={handleChange}
              rows={4}
              placeholder="Tell us more about your wedding — event flow, venues, and your vision..."
              className="border-b-[1px] border-[#F8F5F0] bg-[#2E2526] w-full p-[10px] outline-none placeholder:text-[#F8F5F0] text-[17px] font-[description1]"
            />

            {/* Wedding Location */}
            <input
              type="text"
              name="location"
              value={formData.location}
              onChange={handleChange}
              placeholder="Location of the Event"
              className="border-b-[1px] border-[#F8F5F0] bg-[#2E2526] w-full p-[10px] outline-none placeholder:text-[#F8F5F0] text-[17px] font-[description1]"
            />

            {/* Event Dates */}
            <input
              type="text"
              name="eventDates"
              value={formData.eventDates}
              onChange={handleChange}
              placeholder="Event Dates (e.g. 12–14 February 2027)"
              className="border-b-[1px] border-[#F8F5F0] bg-[#2E2526] w-full p-[10px] outline-none placeholder:text-[#F8F5F0] text-[17px] font-[description1]"
            />
          </div>

          <div className="flex justify-center items-center mt-[30px]">
            <button
              type="submit"
              disabled={result === "Sending..."}
              className="bg-[#907960] text-white font-[description1] px-[15px] text-center mt-[20px] w-[250px] py-[10px] text-[17px] rounded-none disabled:opacity-60"
            >
              {result === "Sending..." ? "Sending..." : "Submit Enquiry"}
            </button>
          </div>

          {showMessage && (
            <p
              role="status"
              className="mt-4 text-center text-[#A4A4A4] font-semibold text-[17px] font-[description1]"
            >
              {result}
            </p>
          )}
        </form>
      </div>

      {/* footer section */}
      <div className="bg-[#3F1116] flex flex-col items-center justify-center pt-[30px] pb-[30px] ">
        <img
          src={rg_logo_footer}
          alt="premium photography"
          className="w-[200px] h-[100px] object-contain"
        />

        <a
          href="mailto:hello@storiesbyrg.com"
          className="font-[description] font-medium text-[13px] text-white mt-[20px] inline-block hover:opacity-70 transition-opacity duration-300"
        >
          hello@storiesbyrg.com
        </a>
        <p className="font-[description] text-[13px] font-medium text-white mt-[20px]">
          Call @ +91 9980685056
        </p>
        <p
          className={cls(
            " text-[13px] font-[description] mt-[30px] mb-[30px] text-[#8b8888] text-center  pl-[20px] pr-[20px]",
          )}
        >
          All Photographs & Films © Stories by RG. All Rights Reserved.
        </p>

        <p
          className={cls(
            " text-[13px] font-[description] mb-[30px] text-[#e2dbdb] text-center pl-[20px] pr-[20px] xl:pl-[380px] xl:pr-[380px]",
          )}
        >
          <p className="font-medium">Tags:</p> Wedding Photography, Cinematic
          Wedding Films, Fine-Art Wedding Photography, Wedding Cinematography,
          Luxury Wedding Films, Destination Weddings, Pre-Wedding Films, Candid
          Wedding Photography, Wedding Stories, Editorial Wedding Photography,
          Wedding Photographers in Bangalore, Hyderabad, Goa, Mumbai, Delhi &
          Beyond.
        </p>
      </div>
    </>
  );
}
